import styled from 'styled-components';

import { noPrint, Theme } from 'baukasten';

import { MAX_SIDEBAR_WIDTH_PIXELS } from './constants';
import type { AiCompanionMode } from './types';

type SidebarContainerProps = {
  $isOpen: boolean;
  $mode: AiCompanionMode;
  $navbarWidth: number;
  $width: number;
  $isDragging: boolean;
};

export const SidebarContainer = styled.div<SidebarContainerProps>`
  position: fixed;
  top: 0;
  right: 0;
  /* fullscreen: fill viewport minus navbar, sidebar: fixed width */
  width: ${props =>
    props.$mode === 'fullscreen'
      ? `calc(100vw - ${props.$navbarWidth}px)`
      : `${props.$width}px`};
  max-width: ${({ $mode }) =>
    $mode === 'fullscreen'
      ? 'none'
      : `min(${MAX_SIDEBAR_WIDTH_PIXELS}px, 100vw)`};
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${Theme.getColor('white')};
  border-left: 1px solid ${Theme.getColor('grey-light-100')};
  box-shadow: 0 0 0 rgb(16 16 16 / 4%), 0 8px 32px rgb(32 32 32 / 8%);
  z-index: 200;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transform: translateX(${({ $isOpen }) => ($isOpen ? '0' : '100%')});
  transition: transform 0.2s ease-in-out
    ${({ $isDragging }) => ($isDragging ? '' : ', width 0.2s ease-in-out')};

  /* Beside the page, people print the page; fullscreen, the conversation is the page. */
  ${({ $mode }) => $mode !== 'fullscreen' && noPrint}
`;

export const ResizeHandle = styled.div<{ $isDragging: boolean }>`
  position: absolute;
  left: -4px;
  top: 0;
  width: 8px;
  height: 100%;
  cursor: col-resize;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    left: 3px;
    top: 0;
    width: 2px;
    height: 100%;
    border-radius: 1px;
    background: ${({ $isDragging }) =>
      $isDragging ? Theme.getColor('blue-dark') : 'transparent'};
    transition: background 0.15s;
  }

  &:hover::after {
    background: ${Theme.getColor('blue-dark')};
  }
`;

export const ChatContainer = styled.div<{ $isDragging: boolean }>`
  flex: 1;
  overflow: hidden;
  pointer-events: ${({ $isDragging }) => ($isDragging ? 'none' : 'auto')};
`;
